import { map } from "ramda";

function instantiateApp({ component, target, props }) {
  let context = new Map();
  let dataStrings = target.getAttribute("data-strings");
  let dataStringsobj;

  if (dataStrings?.length > 0) {
    dataStringsobj = JSON.parse(dataStrings);
    context.set("STRINGS", (key) => (dataStringsobj || {})[key] || key);
  }
  return new component({
    target,
    props: props(target),
    context,
  });
}
export default function ({ component, loader, target, props, immediate }) {
  let apps = [];

  function initialize() {
    // When app already initialized
    destroy();

    const elements = document.querySelectorAll(target);

    if (!elements || elements.length == 0) return;

    if (component) {
      apps = map(
        (element) =>
          instantiateApp({
            component,
            target: element,
            props,
          }),
        elements
      );
    } else if (loader) {
      loader().then((loadedComponent) => {
        apps = map(
          (element) =>
            instantiateApp({
              component: loadedComponent,
              target: element,
              props,
            }),
          elements
        );
      });
    }
  }

  function destroy() {
    if (apps.length > 0) apps.forEach((app) => app.$destroy());
    apps = [];
  }

  if (immediate === true) {
    initialize();
  }

  document.removeEventListener("DOMContentLoaded", initialize);
  document.addEventListener("DOMContentLoaded", initialize);

  document.removeEventListener("page:load", initialize);
  document.addEventListener("page:load", initialize);

  document.removeEventListener("page:restore", initialize);
  document.addEventListener("page:restore", initialize);

  document.removeEventListener("page:after-remove", destroy);
  document.addEventListener("page:after-remove", destroy);
}
